import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import "./styles.css";

class TierListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.selectedCats,
    };

    this.columns = [
      {
        title: "Tier",
        dataIndex: "tier",
        key: "tier",
        // fixed: "left",
        align: "center",
        width: "50px",
        render: (text, record) => {
          return {
            props: {
              style: {
                background:
                  text === "SS"
                    ? "#ff7f7e"
                    : text === "S"
                    ? "#ffbf7f"
                    : text === "A+"
                    ? "#ffdf80"
                    : text === "A"
                    ? "#feff7f"
                    : text === "B+"
                    ? "#beff7f"
                    : text === "B"
                    ? "#7eff80"
                    : text === "B-"
                    ? "#7fffff"
                    : text === "C+"
                    ? "#7fbfff"
                    : text === "C"
                    ? "#807fff"
                    : "#ff7ffe",
              },
            },
            children: <div style={{ fontWeight: "bold" }}>{text}</div>,
          };
        },
      },
      {
        title: "Cat",
        dataIndex: "name",
        key: "name",
        render: (text, record) => {
          let ubers = record.cats.map((element) => {
            return (
              <div
                style={{
                  overflow: "hidden",
                  float: "left",
                  textAlign: "center",
                  maxWidth: "60px",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Link
                  to={
                    "/catinfo/" +
                    element.number.slice(0, 3) +
                    "/" +
                    element.name
                  }
                >
                  <div>
                    <img
                      style={{
                        width: "60px",
                        marginBottom: "-6px",
                      }}
                      src={
                        "https://onestoppress.com/images/" +
                        element.number +
                        "_square_original.png"
                      }
                      alt={element.name}
                    />
                  </div>
                  {element.name}
                </Link>
              </div>
            );
          });

          return <div>{ubers}</div>;
        },
      },
    ];
  }

  render() {
    // const innerHeight = this.props.viewportHeight;
    // const innerHeight = 200;

    return (
      <Table
        columns={this.columns}
        dataSource={this.state.dataSource}
        // scroll={{ x: 1000, y: innerHeight }}
        size="small"
        loading={false}
        pagination={false}
        bordered
        showHeader={false}
      />
    );
  }
}

export default TierListTable;



// WEBPACK FOOTER //
// ./src/components/table/TierListTable.js